export default __webpack_public_path__ + "static/media/location_preview_zoo.93547e75.svg";